import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface SubscribeNewsletterResponseData extends ResponseData {
  data: any // or a specific type if you expect structured data
}

export interface SubscribeNewsletterResponse extends AxiosResponse {
  data: SubscribeNewsletterResponseData
}

export function subscribeNewsletterAPI(
  email: string,
  axiosInstance: AxiosInstance,
): Promise<SubscribeNewsletterResponse> {
  return axiosInstance({
    method: "post",
    url: `/property/subscribe-newsletter/${encodeURIComponent(email)}`,
  })
}
